<template>
  <div class="myorderTable">
    <div class="table-info">
      <div class="info-head">
        <span class="title">收货地址</span>
        <button class="addaddress" @click="addAddress()">新增收货地址</button>
      </div>
      <div
        class="info-middle"
        v-for="(item, index) in addressData.length>0
          ? addressData.slice(0, 1)
          : infoData.slice(0, 1)"
        :key="index"
        @click="getAddress(item.id)"
      >
      <div>
          <span :class="addressId == item.id ? 'active' : ''">{{
            item.username
          }}</span>
          <p>
            {{ item.username }} {{ item.province_name }} {{ item.city_name }}
            {{ item.district_name }} {{ item.address }} {{ item.phone }}
          </p>
        </div>
      </div>
      <div class="info-bottom" v-if="infoData.length > 1">
        <span @click="showdialog()">更多地址</span>
      </div>
         <div class="dialog" v-if="dialog">
      <div
        v-for="(item, index) in infoData"
        :key="index"
        class="listone"
      >
      <div>
        <span :class="addressId == item.id ? 'active' : ''" @click="pushData(item)">{{
            item.username
        }}</span>
        <p @click="pushData(item)">
          {{ item.username }} {{ item.phone }} {{ item.province_name }}
          {{ item.city_name }} {{ item.district_name }} {{ item.address }}
        </p>
      </div>
      </div>
    </div>
      <div class="div"></div>
    </div>
    <div class="table-inventory">
      <div class="inventory-head">
        <span class="title">送货清单</span>
      </div>
      <div class="inventory-middle">
        <table>
          <thead>
            <tr>
              <th class="one">商品</th>
              <th class="two2">品牌</th>
              <th class="twoone">是否干冰包装</th>
              <th class="two0">规格</th>
              <th class="two1">单价</th>
              <th class="two">数量</th>
              <th class="three">金额（元）</th>
            </tr>
          </thead>
          <div class="body">
            <tbody>
              <tr v-for="(item, index) in list" :key="index">
                <td class="one">
                  <div>
                    <p>{{ item.title }}</p>
                  </div>
                </td>
                <td class="two2">
                    <span v-show="item.brand !== null" :style="`background:${item.background_color};color:#ffbb00;padding:1px 10px;border-radius:20px`">{{item.brand}}</span>
                </td>
                <td class="two0">{{ item.sku }}</td>
                <td class="twoone">{{['否','是'][item.is_dry_ice]}}</td>
                <td class="two1">{{ item.price }}</td>
                <td class="two">X{{ item.num }}</td>
                <td class="three">{{ item.total_price }}</td>
              </tr>
            </tbody>
          </div>
        </table>
      </div>
      <div class="div"></div>
    </div>
    <div class="table-invoice">
      <div class="invoice-head" style="margin-bottom:10px;">
        <span class="title">发票信息</span>
      </div>  
      <div class="invoice-middles" v-if="invoicelist && invoicelist.length !== 0"> 
        <p>发票类型：{{['普通发票', '增值税发票', '电子普通发票','','全电普通发票','全电专用发票'][invoicelist.type]}}</p>
        <p>发票抬头：{{ invoicelist.title }}</p>
        <p>税务登记证号：{{ invoicelist.tax_id }}</p>
        <p v-if="invoicelist.type == 1 || invoicelist.type == 5">开户银行名称：{{ invoicelist.bank }}</p>
        <p v-if="invoicelist.type == 1 || invoicelist.type == 5">基本开户账号：{{ invoicelist.account }}</p>
        <p v-if="invoicelist.type == 1 || invoicelist.type == 5">注册地址：{{ invoicelist.address }}</p>
        <p v-if="invoicelist.type == 1 || invoicelist.type == 5">注册电话：{{ invoicelist.phone }}</p>
        <p>电子邮箱：{{ invoicelist.email }}</p>
      </div> 
      <div class="invoice-middle" v-else>
        <div>目前没有添加发票请您</div>
        <span class="change" @click="changeinvoice">添加</span>
        <span>发票</span>
      </div>
    </div>
    <invoiceAddress :shippingAddress="this.addressData.length>0 ? this.addressData.slice(0, 1) : this.infoData.slice(0, 1)"></invoiceAddress>
    <addAddress
      class="dialog-box"
      @updateData="getList"
      v-if="flag"
      :flag="this.flag"
      @flag="disappear"
      :id="this.id"
      :changeState="this.changeState"
    ></addAddress>
    <changeinvoice class="dialog-box" v-if="this.changeinvoiceFlag" :changeinvoiceFlag="this.changeinvoiceFlag" @changeinvoiceFlag="notchangeInfo"></changeinvoice>
    <div class="remark">
      <div class="remark-head" style="margin:25px 0px;">
        <span class="title">订单备注</span>
      </div>  
      <el-input
        type="textarea"
        :rows="2"
        placeholder="请输入内容"
        v-model="textarea">
      </el-input>
    </div>
  </div>
  
</template>

<script>
import addAddress from "../../personalCenter/addressManage/components/addAddress";
import invoiceAddress from './invoiceAdress'
import changeinvoice from './changeinvoice'
export default {
  data() {
    return {
      skuids: sessionStorage.getItem('carList'),
      list:[],
      textarea:'',
      infoData: [],
      pay_type: "",
      addressId: '',
      dialog: false,
      addressData: [],
      flag: false,
      changeState: false,
      id: "",
      changeinvoiceFlag:false,
      invoicelist:[],
      invoiceId:''
    };
  },
  components: {
    addAddress,
    changeinvoice,
    invoiceAddress
  },
  methods: {
    notchangeInfo(params){
      this.changeinvoiceFlag = params
    },
    getList() {
      this.$api.address.addressList({}).then((res) => {
          this.infoData = res.data;
          if(res.data.length>0){
            this.addressId = res.data[0].id
          }else{
            this.addressId = ''
          }
          this.$emit('getAddress',res.data[0])
      });
    },
    disappear(params) {
      this.flag = params;
    },
    pushData(item) {
      this.addressData = [];
      this.addressData.unshift(item);
      this.dialog = !this.dialog;
      this.addressId = item.id
      this.$emit('getAddress',item)
    },
    getAddress(id) {
      this.addressId = id;
    },
    addAddress() {
      this.flag = true;
      this.changeState = false;
    },
    submit() {
      if(this.invoicelist && this.invoicelist.length !== 0){
        this.$api.order
          .submit({
            sku_id: this.skuids,
            address: this.addressId,
            invoice: this.$store.state.invoiceId,
            is_equal_address:this.$store.state.whether_addressStatus,
            remark:this.textarea
          })
          .then((res) => {
            if (res.status == 1) {
              this.$router.push({path:"/shopingCart/payload",query:{order_number : res.data.order_number}});
              this.$store.state.whether_addressStatus = true
            }else{
                this.$message.closeAll()
                this.$message({
                  showClose: true,
                  message: res.msg,
                  type: 'warning',
                  duration:0
                });
            }
          });
      }else{
           this.$message.closeAll()
             this.$message({
                  showClose: true,
                  message:"请先添加发票在提交订单",
                  type: 'warning',
                  duration:0
            });
      }
    },
    getsku_id(){ 
      this.skuids = Array.isArray(this.skuids) ? this.skuids.map((item) => item).join(",") : this.skuids;
      this.$api.shopCar.carlist({
         sku_id:this.skuids
      }).then(res=>{
        if(res.data.detail){
          this.list = res.data.detail
        } else {
          this.$message.closeAll()
          this.$message.warning('已生成订单,请去订单中心去看')
        }
        this.$emit('passVaule',res.data)
      })
    },
    showdialog() {
      this.dialog = !this.dialog;
    },
    changeinvoice(){
      this.changeinvoiceFlag = true
    }
  },
  created() {
    this.$api.invoice.getinvoice({}).then((res) => {
      this.invoicelist = res.data
    });
    this.getList();
    this.getsku_id()
  },
};
</script>

<style lang="less" scoped>
.dialog-box{
  position: fixed;
  left:50%;
  top:50%;
  transform: translate(-50%,-50%);
  z-index:1
}
.el-message--warning{
  height: 70px;
  font-size:24px;
  font-weight: 600;
}
.myorderTable {
  width: 1250px;
  min-height: 768px;
  background: #ffffff;
  border: 1px solid #dddddd;
  box-shadow: 0px -2px 0px 0px #dddddd;
  margin-top: 16px;
  position: relative;
  .dialog {
    .listone{
       div {
        display: flex;
        align-items: center;
        padding-top: 21px;
        font-size: 14px;
        color: #333333;
        span {
          width: 180px;
          height: 38px;
          border: 2px solid #dddddd;
          text-align: center;
          line-height: 38px;
          margin-left: 58px;
          &.active {
            border: 2px solid #ffbb00;
          }
        }
        p {
          margin-left: 14px;
        }
      }
    }
  }
  .div {
    width: 1179px;
    height: 1px;
    border: 1px solid #dddddd;
    margin-top: 19px;
    margin-left: 37px;
  }
  .table-info {
    width: 100%;
    .info-head {
      .title {
        font-size: 18px;
        font-weight: 700;
        color: #333333;
        margin-left: 34px;
        margin-top: 12px;
      }
      .addaddress {
        height: 40px;
        width: 120px;
        font-size: 15px;
        color: #fff;
        cursor: pointer;
        border:0px;
        margin: 15px;
        background: #003871;
      }
    }
    .info-middle {
      height: 75px;
      div {
        display: flex;
        padding-top: 21px;
        font-size: 14px;
        color: #333333;
        span {
          width: 180px;
          height: 38px;
          border: 2px solid #dddddd;
          text-align: center;
          line-height: 38px;
          margin-left: 58px;
          &.active {
            border: 2px solid #ffbb00;
          }
        }
        p {
          margin-left: 14px;
          line-height: 38px;
        }
      }
      span {
        width: 180px;
        height: 38px;
        border: 2px solid #dddddd;
        text-align: center;
        line-height: 38px;
        margin-left: 58px;
      }
      p {
        margin-left: 14px;
      }
    }
    .info-bottom {
      cursor: pointer;
      span {
        font-size: 14px;
        color: #999999;
        margin-left: 60px;
      }
    }
  }
  .table-inventory {
    .inventory-head {
      margin-top: 25px;
      .title {
        width: 90px;
        height: 24px;
        font-size: 18px;
        font-weight: 700;
        color: #333333;
        margin-left: 34px;
      }
    }
    .inventory-middle {
      margin-left: 58px;
      margin-top: 17px;
      min-height: 200px;
      table {
        min-height: 200px;
      }
      thead {
        width: 1134px;
        height: 38px;
        tr {
          width: 1134px;
          height: 38px;
          background: #f5f5f5;
          border: 1px solid #dddddd;
          display: flex;
          align-items: center;
          position: relative;
          .one {
            left: 28px;
            display: flex;
            img {
              width: 65px;
              height: 105px;
              border: 1px solid #ccc;
            }
          }
          .two2{
            left:434px;
          }
          .twoone {
            left: 740px;
          }
          .two {
            left: 874px;
          }
          .two1 {
            left: 654px;
          }
          .two0{
            left: 534px;
          }
          .three {
            left: 989px;
          }
          th {
            font-size: 15px;
            color: #333333;
            position: absolute;
          }
        }
      }
      .body {
        width: 1134px;
        overflow-x: hidden;
        overflow-y: scroll;
      }
      tbody {
        width: 1134px;
        tr {
          width: 1134px;
          height: 70px;
          background: #ffffff;
          border: 1px solid #dddddd;
          border-top: none;
          display: flex;
          align-items: center;
          position: relative;
        }
        .one {
          left: 28px;
          width: 400px;
        }
        .two2{
           left: 434px;
        }
           .twoone {
            left: 740px;
          }
          .two {
            left: 874px;
          }
          .two1 {
            left: 654px;
          }
          .two0{
            left: 544px;
          }
          .three {
            left: 989px;
          }
        td {
          font-size: 14px;
          color: #333333;
          position: absolute;
        }
      }
    }
  }
  .table-invoice {
    margin-bottom: 20px;
    .invoice-head {
      margin-top: 19px;
      .title {
        width: 90px;
        height: 24px;
        font-size: 18px;
        font-weight: 700;
        color: #333333;
        margin-left: 34px;
      }
    }
    .invoice-middles{
        margin-left: 58px;
        p{
          margin-top: 10px;
        }
    }
    .invoice-middle {
      margin-top: 14px;
      display: flex;
      font-size: 14px;
      color: #666666;
      div {
        margin-left: 60px;
      }
      span {
        margin-left: 21px;
      }
      .change {
        font-size: 14px;
        color: #ffbb00;
        cursor: pointer;
      }
    }
  }
  .remark{
    margin-bottom: 20px;
    .remark-head{
      .title {
        font-size: 18px;
        font-weight: 700;
        color: #333333;
        margin-left: 34px;
        margin-top: 12px;
      }
    }
  }  
   /deep/ .el-textarea,.el-textarea__inner{
      width: 500px !important;
      margin-left: 58px;
      border: 1px solid #ccc;
      border-radius: 5px;
   }
}
</style>